import styled from 'styled-components';
import {
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  TwoColScrollableContent,
  FlowStripeWrapper
} from '@flow/components/ui/TwoColScrollLayout';
import em from 'polished/lib/helpers/em';
import Badge from '@flow/components/ui/Badge';

const SingleColumnLayout = styled.section`
  //max-width: 1440px;
  margin: 0 auto;
  padding-top: 6em;
`;

const SingleColumnLayoutHeader = styled.header`
  text-align: center;
  
  h2 {
    text-transform: uppercase;
    font-size: 6em;
    margin-bottom: ${em(4, 6)};
    font-family: Flow-Poster-Bold;
  }
  
  ul {
    font-family: Flow-Inverted;
    margin-bottom: 6em;
    li {
      display: inline-block;
      font-size: 10em;
      border-bottom: ${em(0.6, 10)} solid black;
    }
  }
`;

const SingleColumnLayoutContentWrapper = styled.div`
  max-width: 90em;
  margin: 0 auto 10em;
  text-align: center;
  padding: 0 3em;
  
  p:last-child {
    margin-bottom: 0;
  }
`;

const PageTitle = styled.h1`
  position: relative;
  font-family: Flow-LightDisplay;
  font-size: 10em;
  text-align: center;
  margin-top: ${em(8, 10)};
  margin-bottom: ${em(5, 10)};
  
  @media (max-width: 1920px) {
    font-size: ${100 / (1920 * 0.01)}vw;
    margin-top: ${80 / (1920 * 0.01)}vw;
  }
  
  @media (max-width: 960px) {
    font-size: 5em;
    margin-top: ${em(4, 5)};
  }
`;

const ContentWrapper = styled.div`
  // flex: 1;
  width: calc(100% - 6.6em);
  // overflow-x: hidden;
  box-sizing: border-box;
  padding: 2.5em 3.6em;
  
  @media(max-width: ${props => props.theme.twoColToOneColLayout}px) {
    width: 100%;
  }
`;

const ContentContainer = styled.article`
  h1 {
    font-family: Flow-Inverted;
    font-size: 10em;
    text-transform: uppercase;
    margin-bottom: ${em(7.5, 10)};
    
    @media (max-width: 1920px) {
      font-size: ${100 / (1920 * 0.01)}vw;
      margin-bottom: ${75 / (1920 * 0.01)}vw;
    }
    
    /* @media (max-width: 1200px) {
      font-size: ${100 / (1200 * 0.01)}vw;
      margin-bottom: ${75 / (1200 * 0.01)}vw;
    } */


    @media(max-width: ${props => props.theme.twoColToOneColLayout}px) {
      font-size: ${100 / (1023 * 0.01)}vw;
      margin-bottom: ${75 / (1023 * 0.01)}vw;
    }
    
    @media (max-width: ${props => props.theme.textScaleStopPoint}px) {
      font-size: 5em;
      margin-bottom: ${em(3.75, 5)};
    }
  }
  
  h2 {
    font-family: Flow-Inverted;
    font-size: 6em;
    line-height: ${em(7.2, 6)};
    margin-top: ${em(3, 6)};
    margin-bottom: ${em(3, 6)};
    
    @media (max-width: 1200px) {
      font-size: ${60 / (1200 * 0.01)}vw;
      margin-top: ${30 / (1200 * 0.01)}vw;
      margin-bottom: ${30 / (1200 * 0.01)}vw;
    }
    
    @media (max-width: ${props => props.theme.textScaleStopPoint}px) {
      font-size: 3em;
      margin-bottom: ${em(2, 3)};
      margin-top: ${em(2, 3)};
    }
  }
  
  h3 {
    font-family: Flow-Poster-Bold;
    font-size: 2.1em;
    line-height: ${em(2.4, 2.1)};
    margin-top: ${em(2, 2.1)};
    margin-bottom: ${em(1, 2.1)};
    text-transform: uppercase;
  }
  
  h4 {
    font-size: 1.6em;
    line-height: ${em(2.8, 1.6)};
    text-transform: uppercase;
  }
  
  blockquote {
    font-family: Flow-Inverted;
    font-size: 3.2em;
    line-height: ${em(3.6, 3.2)};
    margin-bottom: ${em(3, 3.2)};
    
    * {
      font-family: Flow-Inverted !important;
      font-size: 1em !important;
      line-height: inherit !important;
      margin: 0 !important;
    }
    
    @media (max-width: 800px) {
      font-size: ${32 / (800 * 0.01)}vw;
    }
    
    @media (max-width: 430px) {
      font-size: 1.72em;
    }
  }
  
  p {
    font-size: 1.6em;
    line-height: ${em(2.8, 1.6)};
    margin-bottom: ${em(3, 1.6)};
  }
  
  ul {
    margin: 2em 0;
    li {
      &:before {
        content: '';
        position: absolute;
        width: ${em(0.8, 1.6)};
        height: ${em(0.8, 1.6)};
        background-color: ${props => props.theme.highlightColor};
        top: ${em(0.8, 1.6)};
        left: 0;
        border-radius: 50%;
      }
    
      position: relative;
      font-size: 1.6em;
      line-height: ${em(2.8, 1.6)};
      margin-bottom: ${em(1, 1.6)};
      padding-left: ${em(2, 1.6)};
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  a {
    color: ${props => props.theme.highlightColor};
    text-decoration: underline;
    
    &:${props => props.theme.hoverProperty} {
      color: black;
    }
  }
  
  img {
    display: inline-block;
    padding-right: 1em;

    &.size-thumbnail {
      width: 150px;
      height: 150px;
    }
  }
  
  img.size-full, img.size-large {
    margin: 2em 0;
    display: block;
    width: 100%;
    height: auto;
  }
  
  .gallery {
    display: flex;
    flex-wrap: wrap;
     
    .gallery-item {
      max-width: 160px;
      
      a {
         display: block;
         
        img {
          padding-bottom: 1em;
          display: block;
          width: auto;
          max-width: 100%;
          height: auto;
          box-sizing: border-box;
        }
      }
      
      figcaption {
        display: block;
        padding-bottom: 1em;
        padding-right: .4em;
        word-break: break-all;
        box-sizing: border-box;
      }
    }
  }
`;

const SubNavigationWrapper = styled.ul`
  z-index: 2;
  position: sticky;
  top: ${props => props.theme.topBarHeight / 10}em;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin-bottom: 4.6em;
  padding-top: 2em;
  z-index: 10;
  
  &.sticky-disabled {
    position: relative;
    top: 0;
  }
  
  li {
    display: inline-block;
    margin-right: 1em;
    margin-bottom: 2em;
    
    &:last-child {
      margin-right: 0;
    }
  }
  
  @media (max-width: ${props => props.theme.narrowTopBarLayout}px) {
    position: relative;
    top: 0;
    padding-top: 0;
  }
`;

const ListIncompleteMessage = styled.span`
  display: inline-block;
  font-family: Flow-Poster-Bold;
  font-size: 2.8em;
  text-transform: uppercase;
  text-align: center;
`;

const ListIncompleteMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 0.2em solid ${props => props.theme.highlightColor};
  border-bottom: 0.2em solid ${props => props.theme.highlightColor};
  box-sizing: border-box;
  margin-bottom: 10em;
  color: ${props => props.theme.highlightColor};
  padding: 2.4em;
  
  @media (max-width: 700px) {
    ${ListIncompleteMessage} {
      .dingbats {
        display: none;
      }  
    }
  }
  
  @media (max-width: 520px) {
    font-size: 80%;
  }
`;

export {
  SingleColumnLayout,
  SingleColumnLayoutHeader,
  SingleColumnLayoutContentWrapper,
  PageTitle,
  ContentWrapper,
  ContentContainer,
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  TwoColScrollableContent,
  FlowStripeWrapper,
  SubNavigationWrapper,
  ListIncompleteMessageWrapper,
  ListIncompleteMessage,
  Badge
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ui/index.tsx